import styled from 'styled-components';
import { Modal, ModalTitle, MODAL_OUTER_PADDING, MODAL_INNER_GAP } from 'design-system/src/components/Modal';
import TrainingVideoEmbed from '../TrainingVideoEmbed/TrainingVideoEmbed';

export type OnboardingModalProps = {
  onClose: () => void;
  practiceTrainingVideoLink: string | null;
};

const CustomModalBody = styled.div`
  // the video has 16px vertical padding, so we need to subtract that from the modal's inner gap and outer padding
  // to keep the spacing consistent with the other modals
  padding: calc(${MODAL_INNER_GAP} - 16px) ${MODAL_OUTER_PADDING} calc(${MODAL_INNER_GAP} - 16px);
`;

/**
 * A modal with information to help new users nagivate the app
 */
export const OnboardingModal = ({ onClose, practiceTrainingVideoLink }: OnboardingModalProps) => {
  return (
    <Modal wide={true} onClose={onClose}>
      <ModalTitle>Welcome to the new Tandem Portal</ModalTitle>
      <CustomModalBody>
        <TrainingVideoEmbed videoLink={practiceTrainingVideoLink ?? ''} />
      </CustomModalBody>
    </Modal>
  );
};
